const e = {
  name: "Suitecase",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M27,0H13v5H3C1.3,5,0,6.3,0,8v29c0,1.7,1.3,3,3,3h34c1.7,0,3-1.3,3-3V8c0-1.7-1.3-3-3-3H27V0z M25,5H15V2h10
			V5z M3,7h34c0.5,0,1,0.5,1,1v11H2V8C2,7.5,2.5,7,3,7z M32,21v4h-2v-4H32z M28,21v6h6v-6h4v16c0,0.5-0.5,1-1,1H3c-0.5,0-1-0.5-1-1
			V21h4v6h6v-6H28z M8,21h2v4H8V21z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as Suitecase
};
